import { IconProps } from '@models/icons';

function DecreaseIcon({ size, color, ...rest }: IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <circle cx="9.16667" cy="9.16667" r="9.16667" fill={color} fillOpacity="0.45"/>
            <path d="M4.7915 9.54175L13.5415 9.54175" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
  );
}

export default DecreaseIcon;
